/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { type SearchProductRecord } from '@/features/search';
import { type ShelfPart } from '@/types/legacy';

export const collectShelfPageNeedsMoreInfoItemsGroupIDs = (
  skuRecords: ShelfPart[] | undefined
): string[] => {
  if (!skuRecords) {
    return [];
  }
  const groupIDs: string[] = [];
  skuRecords.forEach((record) => {
    if (record.vehicleFitment === 'NEEDS_MORE_INFO' && record.partGroupId) {
      groupIDs.push(record.partGroupId);
    }
  });
  return groupIDs;
};

export const collectSearchPageNeedsMoreInfoItemsGroupIDs = (
  skuRecords: SearchProductRecord[] | undefined
): string[] => {
  if (!skuRecords) {
    return [];
  }
  const groupIDs: string[] = [];
  skuRecords.forEach((record) => {
    if (record.vehicleFitment === 'NEEDS_MORE_INFO' && record.partGroupId) {
      groupIDs.push(record.partGroupId);
    }
  });
  return groupIDs;
};
